export class PostPostalCodeParams {
  codePostal: string;
  localite: string;
  langueID: number;
  paysID: number;
  externalApiSourceId: string;

  constructor(data?) {
    Object.assign(this, data);
  }
}
